import React from 'react';
import { ShieldCheckIcon, DownloadIcon, ClockIcon } from 'lucide-react';
const CART_URL = 'https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1';
export function PricingOffer() {
  return <section className="py-8 md:py-14 bg-gradient-to-b from-cream to-white" data-id="element-200">
      <div className="max-w-2xl mx-auto px-4" data-id="element-201">
        {/* Main Pricing Card */}
        <div className="relative bg-white rounded-2xl border-2 border-gold shadow-2xl overflow-hidden" data-id="element-202">
          {/* Top ribbon */}
          <div className="bg-primary text-white text-center py-3 px-4" data-id="element-203">
            <p className="font-bold text-sm uppercase tracking-widest" data-id="element-204">
              LAUNCH OFFER PRICE:
            </p>
          </div>

          <div className="p-5 md:p-10 text-center" data-id="element-205">
            {/* ... keep existing price display ... */}
            <div className="relative inline-block mb-2" data-id="element-206">
              <span className="text-muted line-through text-2xl md:text-3xl font-body" data-id="element-207">
                $97
              </span>
              <span className="absolute -top-1 -right-20 md:-right-24 bg-pain text-white font-black text-xs md:text-sm px-2.5 py-1 rounded-full transform rotate-3 shadow-lg whitespace-nowrap" data-id="element-208">
                72% OFF
              </span>
            </div>

            <div className="mb-3" data-id="element-209">
              <span className="font-heading font-black text-7xl md:text-9xl text-solution leading-none animate-price-glow drop-shadow-lg" data-id="element-210">
                $27
              </span>
            </div>

            <p className="text-muted mb-5 md:mb-8 text-sm md:text-base" data-id="element-211">
              One-time payment · No subscriptions · No hidden charges
            </p>

            {/* CTA Button */}
            <a href="https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1" className="block w-full bg-primary hover:bg-primary-light text-white font-black text-xl md:text-2xl px-8 py-6 rounded-xl transition-all duration-200 transform hover:scale-[1.02] shadow-xl hover:shadow-2xl will-change-transform animate-cta-pulse text-center" data-id="element-212">
              YES — GIVE ME INSTANT ACCESS »
            </a>

            <p className="text-sm text-muted mt-4 flex items-center justify-center gap-2" data-id="element-213">
              <DownloadIcon className="w-4 h-4" data-id="element-214" />
              Instant download of the complete package
            </p>
          </div>

          {/* Urgency */}
          <div className="bg-gold-light/40 border-t-2 border-gold/30 p-4 md:p-6" data-id="element-215">
            {/* ... keep existing urgency content ... */}
            <div className="flex items-start gap-3 text-left max-w-lg mx-auto" data-id="element-216">
              <ClockIcon className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-217" />
              <div data-id="element-218">
                <p className="font-bold text-dark mb-1" data-id="element-219">
                  ⏱️ THIS OFFER EXPIRES SOON
                </p>
                <p className="text-muted text-sm" data-id="element-220">
                  The next cold or fever in your house is coming. The only
                  question is whether you'll have a plan B or not.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Icons */}
        <div className="mt-4 md:mt-6 flex flex-wrap justify-center gap-6 text-muted text-sm" data-id="element-221">
          <div className="flex items-center gap-2" data-id="element-222">
            <ShieldCheckIcon className="w-5 h-5 text-solution" data-id="element-223" />
            <span data-id="element-224">Secure Checkout</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-225">
            <span className="text-lg" data-id="element-226">💳</span>
            <span data-id="element-227">All Cards Accepted</span>
          </div>
        </div>
      </div>
    </section>;
}